/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlEvidence
 */
export interface ControlEvidence {
    /**
     * 
     * @type {string}
     * @memberof ControlEvidence
     */
    s3_key: string;
    /**
     * 
     * @type {string}
     * @memberof ControlEvidence
     */
    filename: string;
}

/**
 * Check if a given object implements the ControlEvidence interface.
 */
export function instanceOfControlEvidence(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "s3_key" in value;
    isInstance = isInstance && "filename" in value;

    return isInstance;
}

export function ControlEvidenceFromJSON(json: any): ControlEvidence {
    return ControlEvidenceFromJSONTyped(json, false);
}

export function ControlEvidenceFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlEvidence {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        's3_key': json['s3_key'],
        'filename': json['filename'],
    };
}

export function ControlEvidenceToJSON(value?: ControlEvidence | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        's3_key': value.s3_key,
        'filename': value.filename,
    };
}

